import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import ConnectionDate from '../../components/checkout/ConnectionDate/ConnectionDate';
import Covid19Constants from '../../common/Covid19Constants';
import { ConfigSelector } from '../reducers/ConfigReducer';
import { PlansSelector } from '../reducers/PlansReducer';

const formSelector = formValueSelector('checkout');
const mapStateToProps = state => ({
  connectionDate: formSelector(state, 'connectionDate'),
  isNoCovid19Confirmed: formSelector(state, Covid19Constants.signup.propertyName),
  isDsl: PlansSelector.getTechnologyType(state) !== 'Fibre',
  hasInstalledOnt: PlansSelector.getUfbReady(state),
  lockDownEndDate: ConfigSelector.getLockDownEndDate(state),
  isCovid19Mode: ConfigSelector.isCovid19Mode(state),
  provider: PlansSelector.getProvider(state),
  isEssential: formSelector(state, 'isEssentialService'),
  delayedDaysForModemDelivery: ConfigSelector.getDelayedDaysForModemDelivery(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
});

const ConnectionDateContainer = connect(mapStateToProps)(ConnectionDate);

export default ConnectionDateContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ConnectionDateContainer.js
 **/